import { useMemo as t } from "react";
import { useCreateCase as o } from "./contact-channels60.js";
const n = () => {
  const e = o();
  return t(() => ({
    createCaseAction: { ...e }
  }), [e]);
};
export {
  n as useEmailActions
};
//# sourceMappingURL=contact-channels11.js.map
